<template>
  <pdl-callout v-if="cartPromotionsMessages?.length" qaid="cart-promotions-callout" class="my-3 w-full">
    <template #content>
      <template v-for="(message, index) in cartPromotionsMessages" :key="index">
        <p class="font-medium">{{ message }}</p>
      </template>
    </template>
  </pdl-callout>
</template>

<script setup>
import {computed} from 'vue';
import {useStore} from '@/store';
import {PdlCallout} from '@pedal/pdl-callout';

const store = useStore();

const cartData = computed(() => store.state.cart.cartData);

const cartPromotionsMessages = computed(() => {
  let messages = [];
  cartData?.value?.appliedOrderPromotions?.forEach((promo) => {
    if (promo?.description) {
      messages.push(promo.description);
    }
  });
  cartData?.value?.potentialOrderPromotions?.forEach((promo) => {
    if (promo?.description) {
      messages.push(promo.description);
    }
  });
  cartData?.value?.appliedProductPromotions?.forEach((promo) => {
    if (promo?.description) {
      messages.push(promo.description);
    }
  });
  cartData?.value?.potentialProductPromotions?.forEach((promo) => {
    if (promo?.description) {
      messages.push(promo.description);
    }
  });
  return messages;
});
</script>
